import Box from "@mui/material/Box";
import { Drawer, IconButton, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

export default function BaseDrawer({
  handleClose, // function to close the modal
  open, // boolean to determine if the modal is open or not
  children, // children to be rendered in the modal
  height,
  title,
  overflow
}) {

  return (
    <>
        <Drawer
        className="newcustomers-container"
        anchor="bottom"
        open={open}
        onClose={handleClose}
        sx={{
            borderRadius: '16px', // Adding rounded corners
            zIndex: 999,
            '& .MuiPaper-root': {
            height: {height}, 
            borderRadius: '16px', // Ensure the paper element also has rounded corners
            backgroundColor: "#F7F7F7",
            },
        }}
        >       

            <Box
            className="centered-content"
            sx={{
                display: "flex",
                alignItems: "center", // Vertically align the elements
                justifyContent: "space-between", // Space out Typography and CloseIcon
                padding: "16px",
                position: "relative", // Required for absolute positioning of the line
            }}
            >
                {/* Typography on the left */}
                <Typography
                    sx={{
                    fontFamily: "Nunito",
                    marginLeft: "16px",
                    fontWeight: "bold",
                    }}
                >
                    {title}
                </Typography>

                {/* Line in the absolute center */}
                <Box
                    onClick={handleClose}
                    sx={{
                    width: "10%",
                    height: "4px",
                    backgroundColor: "#D9D9D9",
                    borderRadius: "2px",
                    cursor: "pointer",
                    position: "absolute", // Position the line absolutely
                    top: "50%", // Vertically center it
                    left: "50%", // Horizontally center it
                    transform: "translate(-50%, -50%)", // Adjust for exact center alignment
                    }}
                />

                {/* Close Icon on the right */}
                <IconButton
                    onClick={handleClose}
                    sx={{
                    marginRight: "16px", // Spacing to the right edge
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            
            <Box
                sx={{
                    flexGrow: 1, // Allow this box to grow and take available space
                    overflowY: overflow ? overflow : "hidden", // Make content scrollable
                    padding: "16px", 
                }}
                className="base-drawer"
            >
                {children}
            </Box>
        </Drawer>
    </>
  );
}
